
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PinPage from './PinPage';
import VerifyPage from './VerifyPage';
import SuccessPage from './SuccessPage';
import FailedPage from './FailedPage';
import TermsConditionPage from './TermsConditionPage';
import StcPinPage from './STC Main LP/PinPage';
import StcVerifyPage from './STC Main LP/VerifyPage';
import StcTermsConditionPage from './STC Main LP/TermsConditionPage';
import StcSuccessPage from './STC Main LP/SuccessPage';
import StcFailedPage from './STC Main LP/FailedPage';

// stckw.kid-security.io serves this same build at the root paths (/,
// /verify, /terms) rather than under /stc, so the STC-only pages need to
// render there too when the app is loaded on that hostname. Every other
// hostname keeps the default (Ooredoo/STC/Zain) pages at those same paths.
const isStcHost = window.location.hostname === 'stckw.kid-security.io';

function App() {
  console.log(window.location.hostname);
  console.log(isStcHost);
  return (
    <Router>
      <Routes>
        <Route path="/" element={isStcHost ? <StcPinPage /> : <PinPage />} />
        <Route path="/verify" element={isStcHost ? <StcVerifyPage /> : <VerifyPage />} />
        <Route path="/success" element={isStcHost ? <StcSuccessPage /> : <SuccessPage />} />
        <Route path="/failed" element={isStcHost ? <StcFailedPage /> : <FailedPage />} />
        <Route path="/terms" element={isStcHost ? <StcTermsConditionPage /> : <TermsConditionPage />} />

        <Route path="/stc" element={<StcPinPage />} />
        <Route path="/stc/verify" element={<StcVerifyPage />} />
        <Route path="/stc/success" element={<StcSuccessPage />} />
        <Route path="/stc/failed" element={<StcFailedPage />} />
        <Route path="/stc/terms" element={<StcTermsConditionPage />} />
      </Routes>
    </Router>
  );
}

export default App;
